import { merge as _merge } from 'lodash'
import zh_cn from 'core/translations/zh_simplified'

export default _merge(zh_cn, {
  error: {
    GUCCI_ERROR_PRODUCT_VARIANT: 'SKU variant. Use the LG Sampling Encoding operation.',
    GUCCI_ERROR_PRODUCT_NOT_VARIANT: 'SKU not variant. Use the LG Encoding operation.',
    GUCCI_SHOES_ERROR_PRODUCT_VARIANT: 'SKU variant. Use the Shoes Sampling Encoding operation.',
    GUCCI_SHOES_ERROR_PRODUCT_NOT_VARIANT: 'SKU not variant. Use the Shoes Encoding operation.',
    GUCCI_ERROR_PRODUCT_MISSING_EAN: 'SKU not variant, EAN missing. Impossible to proceed. Contact support.'
  }
})
